import React from "react";
import { useSearchParams } from "react-router-dom";
import PaymentFailed from "./PaymentFailed";
import PaySuccess from "./SuccessPay";

function PaymentStatus() {
  const [searchParams] = useSearchParams();
  return searchParams.get("state") === "success" ? (
    <PaySuccess />
  ) : (
    <PaymentFailed />
  );
}

export default PaymentStatus;
